export default "__VITE_ASSET__rFmWxH3D__"